export default __webpack_public_path__ + "static/media/08.16.2024 Minutes of the Special Meeting.770a9da9.pdf";